<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-10-22 12:34:40
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-15 23:24:45
 * @Description: 
-->
<template>
  <div class="list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="企业入驻流程" name="first">
        <IntoProcess :interFlowImage="interFlowImage"></IntoProcess>
      </el-tab-pane>
      <el-tab-pane label="注册资料下载" name="second">
        <Download></Download>
      </el-tab-pane>
      <el-tab-pane label="联系我们" name="third">
        <ContactUs :townMsg="townMsg"></ContactUs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ContactUs from "./components/ContactUs";
import Download from "./components/Download";
import IntoProcess from "./components/IntoProcess";
import { getAgencyList, imgSrcGetBase64, imgIndexDB } from "common/js/api"
export default {
  name: "Affairs",
  components: {
    ContactUs,
    Download,
    IntoProcess
  },
  data() {
    return {
      activeName: "first",
      interFlowImage: '',
      townMsg: {
        coverImageUrl: '',
        townAddress: '',
        consultTels: [],
        websites: []
      }
    };
  },
  created() {
    this.getData()
  },
  methods: {
    //获取图片文件Base64
    async getImgBase64(filePath) {
      const { result } = await imgIndexDB(filePath);
      return result;
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    async getData() {
      const { result } = await getAgencyList();
      console.log("result", result)
      if (result.interFlowImage && result.interFlowImage != '') {
        this.interFlowImage = await imgIndexDB(result.interFlowImage)
      }
      const consultTels = result.consultTels ? JSON.parse(result.consultTels) : [];
      const websites = result.websites ? JSON.parse(result.websites) : [];
      if (result.coverImageUrl && result.coverImageUrl != '') {
        this.townMsg.coverImageUrl = await this.getImgBase64(result.coverImageUrl);
      }
      this.townMsg.townAddress = result.townAddress;
      this.townMsg.consultTels = result.consultTels ? JSON.parse(result.consultTels) : [];
      this.townMsg.websites = result.websites ? JSON.parse(result.websites) : [];

    }
  }
};
</script>

<style scoped>
</style>
